import {observer} from "mobx-react-lite";
import CompanyInfo from "../CompanyInfo";
import {useParams} from "react-router";
import {useEffect} from "react";
import mapStore from "../../storage/MapStore";

const CompanyDetail = () => {
    const params = useParams()
    useEffect(() => {
        mapStore.loadCompanyInfo(params.id)
    }, [params.id])
    const club = mapStore.companyDetails || {}
    return (
        <CompanyInfo club={club} teams={club.teams} trainers={club.trainers}/>
    )
}

export default observer(CompanyDetail)